import BoletimSection from "../BoletimSection/BoletimSection";
import CardDotGrid from "../CardDotGrid/CardDotGrid";
import styles from "../CardDotGrid/CardDotGrid.module.css";

function StartupSchool({ startup_school }) {
	const defaultStartup = {
		final_grade: "-",
		max_grade: "-",
		grades: [
			{
				title: "Participação",
				grade: 0,
				max_grade: 5,
			},
			{
				title: "Trabalho em Equipe",
				grade: 0,
				max_grade: 5,
			},
			{
				title: "Cliente",
				grade: 0,
				max_grade: 5,
			},
			{
				title: "Faturamento",
				grade: 0,
				max_grade: 5,
			},
		],
	};

	function colorStyle(final_grade) {
		if (final_grade >= 4) {
			return styles.approved;
		}
        else if (final_grade >= 3) {
            return styles.warning;
        }
        else {
			return styles.reproved;
		}
	}

	return (
		<BoletimSection
			title="Startup School"
			icon="education"
            pill={startup_school.period ? startup_school.period : false}
		>
			<CardDotGrid
				approved={startup_school ? startup_school.approved : "default"}
				finalGrade={
					startup_school
						? startup_school.final_grade
						: defaultStartup.final_grade
				}
				maxGrade={
					startup_school
						? startup_school.max_grade
						: defaultStartup.max_grade
				}
				grades={
					startup_school
						? startup_school.grades
						: defaultStartup.grades
				}
				approvedText={startup_school ? "Concluído" : ""}
				reprovedText={"Participação Parcial"}
				customColorFunction={
					startup_school
						? () => colorStyle(startup_school.final_grade)
						: false
				}
                showIcon={false}
			/>
		</BoletimSection>
	);
}

export default StartupSchool;
